export function removeEscapeHTML(content) {
  return content
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/(<(.*?)>|&\w+;)/g, '')
  //.replace(/\n/g, '<br />');
}